import { Box, Card, Grid, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { isEmpty } from 'lodash-es';
import React, { Component } from 'react';
import { sortByDate, sortByDateReverse } from '../../../../../../../../jsx/actions/utils';
import Currency from '../../../../../commonModules/Currency';
// import EchartsLine from '../../../../../commonModules/interface/Charts/EchartsLine';
// import HighChartLine from '../../../../../commonModules/interface/Charts/HighChartLine';
import RechartsLine from '../../../../../commonModules/interface/Charts/RechartsLine';
// import { InputSelectNative } from '../../../../../commonModules/interface/form-input-inline';
import TabsContent from '../../../../../commonModules/interface/TabsContent';
import { firstDayOfYear, getDateLabels, groupByMonth } from '../../../../../commonModules/utils/statsFunctions';
import DateFilter, { filterDate, YearFilter } from '../../Filter/DateFilter';
import ShopFilter, { filterShop, filterShopCustom } from '../../Filter/ShopFilter';


export class LineStats extends Component{
    state = {
        // searchYear: 2022,
        searchYear: new Date().getFullYear(),

        start_date: firstDayOfYear,
        end_date: new Date(),

        selectShop: [{value:"", label:"Tous les Magasins"}],
        searchType: {value:"", label:""},
        PURCHASE_LIST: [],
        SALE_LIST: [],
        purchaseFiltered: [],
        saleFiltered: [],
    }
    componentDidMount = () => {
        // console.log('=================componentDidMount===================');
        // console.log("Mounting");
        // console.log('====================================');
        this.getHistory()
    }
    getHistory = async () => {
        // console.log('=================getHistory===================');
        // console.log("start");
        // console.log('====================================');
        try {
            const response = await fetch('/stocks/history/product',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ prodID: this.props.product.id }),
                credentials: 'same-origin',
            }); 
            const list = await response.json()
            // console.log({list})
            if( list.error ){ // no errors, return new Object
                console.log("error list fetched", list.error)      
            } else {
                this.setState({
                    PURCHASE_LIST: list.purchases_list,
                    SALE_LIST: list.sales_list,
                })
            }
        } catch (err) {
            console.log("catch error", err)
        }

    }
    // getSaleList = () => {

    // }
    filterOP = (opList, fieldName) => {
        const {selectShop, searchType, searchYear, start_date, end_date } = this.state;
        
        console.log('====================================');
        console.log({opList, fieldName});
        console.log('====================================');
        // let list = filterDate(PURCHASE_LIST, start_date, end_date, "purchase_item_date") // new Date(searchYear, 11, 31)
        let list = filterDate(opList, new Date(searchYear, 0, 1), new Date(searchYear, 11, 31), `${fieldName}_item_date`) // new Date(searchYear, 11, 31)
        // // status
        // if (typeof received == "boolean"){
        //     list = list.filter(item => item.received == received)
        // }
        // // type
        // if (typeof searchType == "boolean"){
        //     list = list.filter(item => item.is_imported == searchType)
        // }
        console.log("selectShop>>",selectShop)
        if (!Array.isArray(selectShop)){
            return []
        }
        let allOption = false;

        selectShop.map(
            (shop) =>{
                if (shop.label === "Tous les Magasins"){
                        allOption = true
                        return list  
                }
            }
        )
        if (allOption){
            return list  
        }
        //console.log("[DEBUG] => listFinal",fieldName," _ ",listFinal)
        // this.setState({[`filtered${opList}`]: list })
        return filterShopCustom(list, `${fieldName}_item_shop`, selectShop)
        // return PURCHASE_LIST
    }
    calcData = () => {
        const { SHOPS } = this.props;
        const { PURCHASE_LIST, SALE_LIST } = this.state;      
        console.log('================IN calcData====================');
        
        let purchase_data = []
        let achat_data = []
        let rea_in_data = []
        let sale_data = []
        let payg_data = []
        let vente_data = []
        let rea_data = []
        let commercial_data = []
        let SERIES_RECHARTS = []
        
        let purchase_object = {} // {"octobre 2018": 16000, septembre:16000}
        let sale_object = {} // {"octobre 2018": 16000, septembre:16000}
        
        let dateLabels = getDateLabels("year", this.state.searchYear)

        let purchaseFiltered = this.filterOP(PURCHASE_LIST, "purchase")
        let saleFiltered = this.filterOP(SALE_LIST, "sale")

        console.log({
            dateLabels, 
            purchaseFiltered,
            saleFiltered,
        });     
        console.log("YEAR => ", this.state.searchYear)
           
        purchase_object = groupByMonth(purchaseFiltered, "purchase_item_date")
        sale_object = groupByMonth(saleFiltered, "sale_item_date")

        let history = []

        console.log("DEBUG", SHOPS)
        purchaseFiltered.forEach( item => {
            let formatItem = {
                date: item.purchase_item_date,
                nature: item.purchase_item_nature == "reapprovisionnement" ? "Reappro In" : item.purchase_item_nature ,
                shop: SHOPS[item.purchase_item_shop].name,
                quantity: item.quantity,
                PU: item.purchase_item_pu
            }
            history.push(formatItem)
        })
        saleFiltered.forEach( item => {
            let formatItem = {
                date: item.sale_item_date,
                nature: item.sale_item_nature == "reapprovisionnement" ? "Reappro Out" : item.sale_item_nature ,
                shop: SHOPS[item.sale_item_shop].name,
                quantity: (item.quantity * -1),
                PU: item.sale_item_PU
            }
            history.push(formatItem)
        })

        history = sortByDate(history, "date")
        
        dateLabels.map((date, i) => {
            // bckg_real_data.push('rgba(255, 206, 86, 0.6)')// chart color
            // bckg_purchase_data.push('rgba(54, 162, 235, 0.6)')// chart color
            // bckg_available_data.push('rgba(230, 60, 134, 0.6)')// chart color
            let totalIn = 0
            let dataByTypeP = {
                "achat": 0,
                "reapprovisionnement": 0
            }
            if (purchase_object[date]){
                purchase_object[date].forEach(buy => {
                    totalIn += buy.quantity
                    dataByTypeP[buy.purchase_item_nature] +=  buy.quantity
                })
            }
            purchase_data[i] = totalIn
            achat_data[i] = dataByTypeP.achat
            rea_in_data[i] = dataByTypeP.reapprovisionnement

            let totalOut = 0
            let dataByTypeS = {
                "payg": 0,
                "vente": 0,
                "reapprovisionnement": 0,
                "commercial": 0
            }
            if (sale_object[date]){
                sale_object[date].forEach(buy => {
                    totalOut += buy.quantity
                    dataByTypeS[buy.sale_item_nature] +=  buy.quantity
                })
            }
            sale_data[i] = totalOut
            payg_data[i] = dataByTypeS.payg
            vente_data[i] = dataByTypeS.vente
            rea_data[i] = dataByTypeS.reapprovisionnement
            commercial_data[i] = dataByTypeS.commercial

            console.log(date, '====================================');
            console.log("vente", dataByTypeS.vente, "payg", dataByTypeS.payg, "commercial", dataByTypeS.commercial);
            console.log('====================================');

            SERIES_RECHARTS.push({
                name: date,
                // Sorties : totalOut,
                Payg : dataByTypeS.payg,
                Ventes : dataByTypeS.vente,
                "Reappro Out" : dataByTypeS.reapprovisionnement,
                Commercial : dataByTypeS.commercial,
                // Entrées : totalIn,
                Achat : dataByTypeP.achat,
                "Reappro In" : dataByTypeP.reapprovisionnement
            })
        })
        
    
        console.log({ 
            dateLabels, 
            sale_object, 
            purchase_object,
            sale_data,
            purchase_data,
            payg_data,
            vente_data,
            rea_data,
            SERIES_RECHARTS
        });     
              
        // series: [{
        //     name: 'Employees',
        //     color: 'rgba(165,170,217,1)',
        //     data: [150, 73, 20],
        //     pointPadding: 0.3,
        // }, {
        //     name: 'Employees Optimized',
        //     color: 'rgba(126,86,134,.9)',
        //     data: [140, 90, 40],
        //     pointPadding: 0.4,
        
        // }]
    
        return {
            labels: dateLabels,
            series:[
                // {
                //     name:'Total Entrées',
                //     data: purchase_data,
                //     pointPadding: 0.5,
                //     color: 'rgba(54, 162, 235, 0.6)'// chart color
                // },
                {
                    name:'Achats',
                    data: achat_data,
                    pointPadding: 1,
                    smooth: true
                    // color: 'rgba(54, 162, 235, 0.6)'// chart color
                },
                {
                    name:'Reappro In',
                    data: rea_in_data,
                    pointPadding: 1,
                    // color: 'rgba(54, 162, 235, 0.6)'// chart color
                },
                // {
                //     name: 'Total Sorties',
                //     data: sale_data,
                //     pointPadding: 0.3,
                //     color: 'rgba(255, 206, 86, 0.8)'// chart color
                // },
                {
                    name: 'Payg',
                    data: payg_data,
                    pointPadding: 0.3,
                    // color: 'rgba(255, 206, 86, 0.8)'// chart color
                },
                {
                    name: 'Vente',
                    data: vente_data,
                    pointPadding: 0.3,
                    // color: 'rgba(255, 206, 86, 0.8)'// chart color
                },
                {
                    name: 'Commercial',
                    data: commercial_data,
                    pointPadding: 0.3,
                    // color: 'rgba(255, 206, 86, 0.8)'// chart color
                },
                {
                    name: 'Reappro Out',
                    data: rea_data,
                    pointPadding: 0.3,
                    // color: 'rgba(255, 206, 86, 0.8)'// chart color
                },
            ],
            purchaseFiltered,
            saleFiltered,
            history,
            SERIES_RECHARTS
        }
        
    }

    handleSelectMulti = (option, name) => {
        if(option){
            this.setState({                
                [name]: option,
            })
        } else {
            this.setState({
                [name]: {label: "", value: ""},
            })

        }
    }
    render(){
        const { PURCHASE_LIST, SALE_LIST } = this.state;
        let data = [{labels: [], series: {}}]
        // console.log('====================================');
        // console.log({PURCHASE_LIST, SALE_LIST});
        // console.log('====================================');
        if (!isEmpty(PURCHASE_LIST) ) { 
            data = this.calcData()
        }
        // console.log("LINE CHART ", this.state);
        
        return (
      
            <Box p={1}>  
                <Grid container spacing={1}>
                    <Grid item xs={12} md={4}>
                            {/* <DateFilter
                                handleChangeDate={(date, name) => this.setState({ [name]: date })}
                                {...this.state}
                            /> */}
                            <YearFilter
                                handleChange={(e) => this.setState({ searchYear: parseInt(e.target.value) })}
                                searchYear={this.state.searchYear}
                            />
                            <ShopFilter
                                value={this.state.selectShop}
                                handleSelect={this.handleSelectMulti}
                            />
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Card >
                            <Box p={1}>
                                <TabsContent
                                    labels={["Statistiques", "Historique"]}
                                    variant="fullWidth"
                                >
                                    <Box p={1}>
                                        <RechartsLine 
                                            data={data.SERIES_RECHARTS}
                                            title={`Analyse Entrées Sorties ${this.state.searchYear}`}
                                        />
                                    </Box>
                                    {/* <Box p={1}>
                                        <EchartsLine 
                                            labels={data.labels}
                                            series={data.series}
                                            title={`Analyse Entrées Sorties ${this.state.searchYear}`}
                                        />
                                    </Box>
                                    <Box p={1}>
                                        <HighChartLine 
                                            title={`Analyse Entrées Sorties ${this.state.searchYear}`}
                                            titleY="Quantité"
                                            categories={data.labels}
                                            series={data.series}
                                            // title={this.props.title}
                                            // type="column"
                                            // colors={data.bckg}
                                            // disableLegend={true}
                                        />
                                    </Box> */}
                                    <Box p={1}>  
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Date</TableCell>
                                                    <TableCell>Opération</TableCell>
                                                    <TableCell>Magasin</TableCell>
                                                    <TableCell>Quantité</TableCell>
                                                    <TableCell>PU</TableCell>
                                                    {/* <TableCell>Total</TableCell> */}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {/* {data.purchaseFiltered && data.purchaseFiltered.reverse().map(item =>
                                                    <TableRow>
                                                        <TableCell>{new Date(item.purchase_item_date).toLocaleDateString()}</TableCell>
                                                        <TableCell>{item.purchase_item_nature}</TableCell>
                                                        <TableCell>{SHOPS[item.purchase_item_shop].name}</TableCell>
                                                        <TableCell>{item.quantity}</TableCell>
                                                        <TableCell><Currency value={item.purchase_item_pu} /></TableCell>
                                                    </TableRow>
                                                )} */}
                                                {data.history && data.history.reverse().map(item =>
                                                    <TableRow>
                                                        <TableCell>{new Date(item.date).toLocaleDateString()}</TableCell>
                                                        <TableCell>{item.nature}</TableCell>
                                                        <TableCell>{item.shop}</TableCell>
                                                        <TableCell style={{textAlign: "right", color: (item.quantity < 0 ? "red" :"green")}}>{item.quantity}</TableCell>
                                                        <TableCell><Currency value={item.PU} /></TableCell>
                                                        {/* <TableCell><Currency value={item.price} /></TableCell> */}
                                                    </TableRow>
                                                )}
                                                
                                            </TableBody>
                                        </Table>
                                    </Box>

                                </TabsContent>
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        )
    }
}